"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroup = InputGroup;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const Base = _styledComponents.default.fieldset`
  border-color: ${p => p.theme.colors.antiFlashWhite};
  border-radius: ${p => (0, _polished.rem)(p.theme.radii[1])};
  border-style: solid;
  border-width: ${(0, _polished.rem)(2)};
  padding: ${p => (0, _polished.rem)(p.theme.spacing[1])};
`;
const Label = _styledComponents.default.legend`
  background-color: inherit;
  padding: 0 ${p => (0, _polished.rem)(p.theme.spacing[0])};
  margin-left: ${p => (0, _polished.rem)(-p.theme.spacing[0])};
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
function InputGroup({
  children,
  label
}) {
  return /*#__PURE__*/_react.default.createElement(Base, null, label && /*#__PURE__*/_react.default.createElement(Label, null, label), children);
}